export default __webpack_public_path__ + "static/media/close.643ff081.svg";